import {FaqItem} from "@olivades/pattern-lib";

export const faqData: FaqItem[] = [
  {
    question: {
      fr: "La piscine est-elle chauffée ?",
      en: "Is the pool heated?"
    },
    answer: {
      fr: "Oui, La piscine est chauffée à 28 degrés.",
      en: "Yes, the pool is heated to 28 degrees."
    }
  },
  {
    question: {
      fr: "Le Jacuzzi est-il payant ?",
      en: "Is the Jacuzzi extra?"
    },
    answer: {
      fr: "Non, le tarif à la nuitée inclut l'accès au Jacuzzi.",
      en: "No, the nightly rate includes access to the Jacuzzi."
    }
  },
  {
    question: {
      fr: "Le linge de lit ainsi que les serviettes sont-ils mise à disposition ?",
      en: "Are bed linen and towels provided?"
    },
    answer: {
      fr: "Oui, les draps et serviettes de toilettes sont fournis.",
      en: "Yes, sheets and towels are provided."
    }
  },
  {
    question: {
      fr: "Les appartements sont-ils chauffés / climatisés ?",
      en: "Are the apartments heated/air-conditioned?"
    },
    answer: {
      fr: "Oui, tous les appartements disposent d'une climatisation réversible.",
      en: "Yes, all apartments have reversible air conditioning."
    }
  },
  {
    question: {
      fr: "Jusqu'à quelle heure se fait le check-in ?",
      en: "Until what time can I check in?"
    },
    answer: {
      fr: "Le check-in se fait entre 16h et 19h. Passé 19h, n'hésitez pas à nous prévenir afin de vous transmettre le protocole d'arrivée tardive.",
      en: "Check-in is from 4pm to 7pm. After 7pm, please let us know so we can send you the late check-in instructions."
    }
  },
  {
    question: {
      fr: "Les appartements sont-ils équipés d'un lave vaisselle ?",
      en: "Do the apartments have a dishwasher?"
    },
    answer: {
      fr: "Seuls les appartements Famille et Confort possèdent un lave-vaisselle.",
      en: "Only the Family and Comfort apartments have a dishwasher."
    }
  },
  {
    question: {
      fr: "Les appartements sont-ils équipés d'un lave linge ?",
      en: "Do the apartments have a washing machine?"
    },
    answer: {
      fr: "Seuls les appartements Famille et Confort possèdent un lave-linge.",
      en: "Only the Family and Comfort apartments have a washing machine."
    }
  }
];
